<template>
  <div v-if="!isLocalhost" class="turnstile-wrapper">
    <div ref="turnstileContainer"></div>
  </div>
</template>

<script>
export default {
  name: 'TurnstileWidget',
  props: {
    sitekey: {
      type: String,
      default: () => process.env.VUE_APP_CLOUDFLARE_TURNSTILE_SITE_KEY,
    },
  },
  data() {
    return {
      widgetId: null,
    };
  },
  computed: {
    isLocalhost() {
      if (typeof window === 'undefined') return false;
      const hostname = window.location.hostname;
      return hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
    },
  },
  mounted() {
    if (this.isLocalhost) {
      this.$emit('token-received', 'localhost-dev-token');
      return;
    }
    this.initTurnstile();
  },
  beforeDestroy() {
    if (window.turnstile && this.widgetId !== null) {
      try {
        window.turnstile.remove(this.widgetId);
      } catch (e) {
        console.warn('Turnstile remove error:', e);
      }
    }
  },
  methods: {
    initTurnstile() {
      if (window.turnstile) {
        this.renderWidget();
      } else {
        const scriptId = 'cf-turnstile-script';
        let script = document.getElementById(scriptId);
        if (!script) {
          script = document.createElement('script');
          script.id = scriptId;
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
        const checkTurnstile = setInterval(() => {
          if (window.turnstile) {
            clearInterval(checkTurnstile);
            this.renderWidget();
          }
        }, 100);
        setTimeout(() => clearInterval(checkTurnstile), 10000);
      }
    },
    renderWidget() {
      if (!this.$refs.turnstileContainer || this.widgetId !== null) {
        return;
      }
      try {
        this.widgetId = window.turnstile.render(this.$refs.turnstileContainer, {
          sitekey: this.sitekey,
          callback: (token) => {
            this.$emit('token-received', token);
          },
          'error-callback': () => {
            this.$emit('token-expired');
          },
          'expired-callback': () => {
            this.$emit('token-expired');
          },
        });
      } catch (e) {
        console.error('Turnstile render error:', e);
      }
    },
    reset() {
      if (this.isLocalhost) {
        this.$emit('token-received', 'localhost-dev-token');
        return;
      }
      if (window.turnstile && this.widgetId !== null) {
        try {
          window.turnstile.reset(this.widgetId);
        } catch (e) {
          console.warn('Turnstile reset error:', e);
        }
      }
    },
  },
};
</script>

<style scoped>
.turnstile-wrapper {
  margin: 15px 0;
  display: flex;
  justify-content: center;
}
</style>
